import React, { useState, useEffect } from 'react';

const AgeVerification = () => {
  const [isVerified, setIsVerified] = useState(true); // Default to true, will check in useEffect
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already verified their age in this session
    const ageVerified = sessionStorage.getItem('ageVerified');
    
    if (!ageVerified) {
      setIsVerified(false);
      setIsVisible(true);
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
    }
  }, []);

  const handleVerify = (confirmed) => {
    if (confirmed) {
      sessionStorage.setItem('ageVerified', 'true');
      setIsVerified(true);
      setIsVisible(false);
      document.body.style.overflow = 'unset';
    } else {
      // Redirect to a safe page if they're under 18
      window.location.href = 'https://www.google.com';
    }
  };

  if (isVerified || !isVisible) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.95)',
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'var(--ivory)',
        maxWidth: '500px',
        width: '100%',
        padding: '48px 40px',
        textAlign: 'center',
        borderRadius: '0',
        border: '2px solid var(--burgundy)'
      }}>
        <h2 style={{
          fontFamily: 'Cinzel, serif',
          fontSize: '32px',
          color: 'var(--text-primary)',
          marginBottom: '24px',
          fontWeight: '600'
        }}>
          Age Verification
        </h2>
        
        <p style={{
          fontFamily: 'Raleway, sans-serif',
          fontSize: '16px',
          color: 'var(--text-secondary)',
          lineHeight: '1.7',
          marginBottom: '32px'
        }}>
          This website contains adult content. You must be 18 years or older to enter.
        </p>

        <div style={{
          display: 'flex',
          gap: '16px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={() => handleVerify(true)}
            style={{
              padding: '14px 32px',
              background: 'var(--burgundy)',
              color: 'var(--ivory)',
              border: 'none',
              fontFamily: 'Raleway, sans-serif',
              fontSize: '16px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              letterSpacing: '0.5px',
              minWidth: '140px'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#72283a';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'var(--burgundy)';
            }}
          >
            I AM 18+
          </button>
          
          <button
            onClick={() => handleVerify(false)}
            style={{
              padding: '14px 32px',
              background: 'transparent',
              color: 'var(--text-primary)',
              border: '1px solid var(--border-medium)',
              fontFamily: 'Raleway, sans-serif',
              fontSize: '16px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              letterSpacing: '0.5px',
              minWidth: '140px'
            }}
            onMouseEnter={(e) => {
              e.target.style.borderColor = 'var(--burgundy)';
              e.target.style.color = 'var(--burgundy)';
            }}
            onMouseLeave={(e) => {
              e.target.style.borderColor = 'var(--border-medium)';
              e.target.style.color = 'var(--text-primary)';
            }}
          >
            I AM UNDER 18
          </button>
        </div>

        <p style={{
          fontFamily: 'Raleway, sans-serif',
          fontSize: '13px',
          color: 'var(--text-light)',
          marginTop: '32px',
          fontStyle: 'italic'
        }}>
          By entering this website, you agree that you are of legal age and that you accept our Terms & Conditions.
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;
